var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.capacity && _vm.item.count)?_c('div',{staticClass:"slot"},_vm._l((_vm.item.capacity),function(index){return _c('div',{key:index,staticClass:"slot-seat",class:{'is-active': index <= _vm.item.count.filled}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }